import script from "./ModalInsufficientPermissions.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalInsufficientPermissions.vue?vue&type=script&lang=ts&setup=true"

import "./ModalInsufficientPermissions.vue?vue&type=style&index=0&id=f08362fc&lang=scss"

const __exports__ = script;

export default __exports__